const myStyles = theme => ({
    avatar: {
        width: "150px",
        height: "150px",
        [theme.breakpoints.down("sm")]: {
          width: "100px",
          height: "100px"
        },
    
        [theme.breakpoints.down("xs")]: {
          width: "60px",
          height: "60px"
        }
      },
})

export default myStyles